import React, { useState } from 'react'
import { BiCheck } from "react-icons/bi";
import "./style.css"

export default function Index(props) {
    const [orders, setOrders] = useState([
        "Emotional (Intelligence) Assessment",
        "Inductive Reasoning Assessment",
        "Proprioception Assessment",
        "Memory Assessment",
        "Hemisphere Dominance Assessment",
        "Verbal Reasoning Assessment",
        "Deductive Reasoning Assessment",
        "Working Memory Assessment"
    ])

    return (
        <div className='assess-progress-container'>
            <div className='progress-title'>Progress</div>
            <div className='assess-progress-wrap'>
                {orders.map((order, index) =>
                    <div key={index} className='assess-progress-order'>
                        <div className='assess-progress-content'>{order}</div>
                        <div className='assess-progress' style={{ backgroundColor: props.progress > index ? "#1FD008" : "" }}>
                            {props.progress > index ? <BiCheck size={40} /> : ""}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
